import { IngredientLabel } from '@portal/types/studio/studio';
import { Fragment } from 'react';
import { Typography } from '@ag1/ui';
import { CustomPortableText } from '@portal/shared/studio/PortableText';
import styles from './IngredientModalDE.module.scss';

interface NutritionItem {
  _key?: string;
  _id?: string;
  isLineBreak?: boolean;
  name?: string;
  value?: string;
  percentage?: string;
  thickness?: string;
}

type IngredientLabelDetails = NonNullable<IngredientLabel['ingredientLabelDetails']>;

interface IngerdientLabelDetailProps {
  props: IngredientLabelDetails;
}

export const IngredientModalDE = ({ props }: IngerdientLabelDetailProps) => {
  return (
    <>
      {props && (
        <div className={styles.modalContainer}>
          <div className={styles.logo_section_wrapper}>
            <div className={styles.icon_section_wrapper}>
              <div>
                {/* <p className={styles.bold}>Verzehrempfehlung</p> */}
                <p className={styles.icon_section_des}>{props?.descriptionA}</p>
              </div>

              <div>
                {/* <p className={styles.bold}>Aufbewahrungshinweis</p> */}
                <p className={styles.icon_section_des}>{props?.descriptionB}</p>
              </div>
            </div>
          </div>

          <div className={styles.nutrition_facts}>
            {props.nutrition?.map(
              (
                nutritionItem: NutritionItem,
                docIndex: number,
                allNutritionDocs: NutritionItem[]
              ) => {
                const {
                  _key: itemKey,
                  _id: itemId,
                  isLineBreak,
                  name,
                  value,
                  percentage,
                  thickness
                } = nutritionItem;

                const isFact = !isLineBreak;
                // const currentIsLineBreak = isLineBreak;

                let shouldRenderDividerAfterFact = false;
                if (isFact) {
                  shouldRenderDividerAfterFact = true; // Default to true for facts
                  const nextNutritionDocument: NutritionItem | undefined =
                    allNutritionDocs[docIndex + 1];
                  if (nextNutritionDocument && nextNutritionDocument.isLineBreak) {
                    shouldRenderDividerAfterFact = false;
                  }
                }

                return (
                  <Fragment key={itemKey || itemId || `nut-de-${docIndex}`}>
                    {isFact && (
                      <>
                        {name === 'VITAMINS_TITLE_MARKER' ? (
                          <>
                            <div
                              className={`${styles.nutrition_facts_subTitle} ${styles.left} ${styles.marginTop}`}>
                              <p className={`${styles.vitaminTitle} ${styles.bold}`}>
                                VITAMINE UND MINERALSTOFFE
                              </p>
                            </div>
                            {shouldRenderDividerAfterFact && <div className={styles.divider} />}
                          </>
                        ) : (
                          // Render standard nutrition fact
                          <>
                            <div className={styles.nutrition_fact}>
                              <p className={`${styles.nutrition_name} ${styles.elem}`}>{name}</p>
                              <div className={styles.row}>
                                <p className={styles.elem}>{value}</p>
                                {percentage ? (
                                  <p className={styles.elem}>{percentage}</p>
                                ) : (
                                  <p className={styles.elem}>&nbsp;</p>
                                )}
                              </div>
                            </div>
                            {shouldRenderDividerAfterFact && <div className={styles.divider} />}
                          </>
                        )}
                      </>
                    )}
                    {isLineBreak && (
                      <div
                        className={thickness === 'thick' ? styles.dividerThick : styles.divider}
                      />
                    )}
                  </Fragment>
                );
              }
            )}
          </div>
          <div className={styles.nutrition_des}>
            {props?.nutritionDescription?.map(
              (e) =>
                e.description && (
                  <div
                    className={`${styles.nutrition_des_fact}`}
                    key={e._key || `desc-${Math.random()}`}>
                    <Typography variant="body" component="p" size="2" className={styles.elemLeft}>
                      <CustomPortableText value={e.description} />
                    </Typography>
                  </div>
                )
            )}
          </div>

          {props?.otherIngredient && (
            <div className={`${styles.otherIngredient}`}>
              <Typography variant="body" component="p" size="2" className={styles.bold}>
                <CustomPortableText value={props.otherIngredient.title ?? []} />
              </Typography>
              <Typography
                variant="body"
                component="p"
                size="2"
                className={styles.otherIngredient_detail}>
                <CustomPortableText value={props.otherIngredient.description ?? []} />
              </Typography>
            </div>
          )}
          {props?.contains && (
            <div>
              <div className={`${styles.contain} ${styles.small}`}>
                <Typography
                  variant="body"
                  component="p"
                  size="2"
                  className={`${styles.contain_title} ${styles.bold}`}>
                  {props.containsMicrocopy}
                </Typography>
                <Typography variant="body" component="p" size="2" className={styles.contain_detail}>
                  <CustomPortableText value={props.contains.containsIngredient ?? []} />
                </Typography>
              </div>
              <Typography
                variant="body"
                component="p"
                size="2"
                className={`${styles.contain_des} ${styles.small}`}>
                <CustomPortableText value={props.contains.description ?? []} />
              </Typography>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default IngredientModalDE;
